import { useCallback, useState } from "react";
import { logError, LogCategory } from "utils/sentryLogger";
import { triggerCsvDownload } from "./csReportsApi";

export const useCSReportRunner = ({ fetchJson, fetchCsv, errorTag }) => {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const run = useCallback(async (params) => {
    if (!params) return;
    setLoading(true);
    setError(null);
    try {
      const { rows: result } = await fetchJson(params);
      setRows(result);
    } catch (e) {
      const msg = e?.detail || e?.message || "Failed to load report.";
      setError(msg);
      logError(`CS Reports: ${errorTag} fetch failed`, e, {
        category: LogCategory.ERROR,
      });
    } finally {
      setLoading(false);
    }
  }, [fetchJson, errorTag]);

  const download = useCallback(async (params) => {
    if (!params) return;
    setDownloading(true);
    setError(null);
    try {
      const response = await fetchCsv(params);
      await triggerCsvDownload(response);
    } catch (e) {
      const msg = e?.detail || e?.message || "Failed to download CSV.";
      setError(msg);
      logError(`CS Reports: ${errorTag} CSV failed`, e, {
        category: LogCategory.ERROR,
      });
    } finally {
      setDownloading(false);
    }
  }, [fetchCsv, errorTag]);

  const reset = useCallback(() => {
    setRows(null);
    setError(null);
  }, []);

  return { rows, loading, downloading, error, run, download, reset };
};
